import { __extends } from "tslib";
import { EventBase } from '@awayjs/core';
/**
 * A FocusEvent is dispatched when a entity is focused
 */
var TextfieldEvent = /** @class */ (function (_super) {
    __extends(TextfieldEvent, _super);
    /**
     * Create a new MouseEvent object.
     * @param type The type of the MouseEvent.
     */
    function TextfieldEvent(type) {
        return _super.call(this, type) || this;
    }
    /**
     * Creates a copy of the MouseEvent object and sets the value of each property to match that of the original.
     */
    TextfieldEvent.prototype.clone = function () {
        var result = new TextfieldEvent(this.type);
        return result;
    };
    /**
     * Defines the value of the type property of a focusIn3d event object.
     */
    TextfieldEvent.CHANGED = 'onChanged';
    return TextfieldEvent;
}(EventBase));
export { TextfieldEvent };
